"use client";

import { memo } from "react";
import { UseFormReturn } from "react-hook-form";

import { Button } from "@/components/ui/button";
import { Palmtree } from "lucide-react";
import { IHolidaySearchSchema } from "../../schema/holiday-search.schema";
import SelectHolidayCity from "./select-holiday-city";

interface HolidayFieldProps {
  form: UseFormReturn<IHolidaySearchSchema>;
}

const SUMMARY_BUTTON_CLASS =
  "pointer-events-none h-8 rounded-lg border border-border/60 bg-background/85 px-2 text-xs font-semibold text-foreground shadow-xs md:rounded-md md:border-0 md:bg-primary/10 md:px-4 md:text-sm md:text-primary md:shadow-none";

const SearchType = memo(function SearchType() {
  return (
    <Button
      type="button"
      variant="ghost"
      className={SUMMARY_BUTTON_CLASS}
    >
      <Palmtree className="h-4 w-4" />
      Holiday
    </Button>
  );
});

const Location = memo(function Location({ form }: HolidayFieldProps) {
  return <SelectHolidayCity form={form} popoverModal />;
});

export const HolidayFields = {
  SearchType,
  Location,
};
